<template>
    <div>
        <el-button type="primary"
                   @click="startTour"
                   :disabled="!tourAvailable">
            {{ $t(tourNameKey) }}
        </el-button>

        <el-tour v-model="tourStart">
            <el-tour-step v-for="step in tourSteps"
                          :key="step.id"
                          :target="step.target"
                          :title="$t(step.title)"   
                          :description="$t(step.description)" />

        </el-tour>
    </div>
</template>

<script lang="js">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            tourNameKey: {
                type: String,
                default: "helpInfo.defaultToursName",
            },
            tourSteps: {
                type: Array,
                default() {
                    return []
                }
            },
            tourAvailable: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                tourStart: false,
            };
        },
        methods: {
            startTour() {
                const result = document.getElementById("tab-fileUpload");
                if (result != null) {
                    result.click();
                }
                this.tourStart = true;
            },
        }
    })
</script>